import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import SEO from 'components/shared/SEO'
import Slider from 'components/Slider/Slider'
import Map from 'components/Map/Map'
import About from 'components/About/About'
import Promo from 'components/Promo/Promo'
// import Contact from 'components/Contact/Contact'

const IndexPage = ({ data }) => {
  const HOMEPAGE = data.wpgraphql.page.PageHome

  const slides = HOMEPAGE.bannerSlides.map(
    ({ bannerSlideHighlight, bannerSlideText, bannerSlideImage }) => ({
      src: bannerSlideImage.imageFile.childImageSharp.fluid,
      alt: bannerSlideImage.title,
      highlightedText: bannerSlideHighlight,
      text: bannerSlideText,
    })
  )

  const features = HOMEPAGE.promoCards.map(
    ({ promoCardNumber, promoCardText, promoCardUnit }) => ({
      number: promoCardNumber,
      text: promoCardText,
      unit: promoCardUnit || '',
    })
  )

  const maps = HOMEPAGE.maps.map(({ mapsLink, mapsCity }) => ({
    title: mapsCity,
    link: mapsLink,
  }))

  const cards = HOMEPAGE.aboutCards.map(
    ({
      aboutCardHeader: { aboutCardHeaderHighlight, aboutCardHeaderText },
      aboutCardDescription,
      aboutCardImg,
    }) => ({
      image: aboutCardImg.imageFile.childImageSharp.fluid,
      imageAlt: aboutCardImg.title,
      header: {
        title: aboutCardHeaderText,
        highlight: aboutCardHeaderHighlight,
      },
      description: aboutCardDescription,
    })
  )

  // const localization = {
  //   city: 'Luxembourg',
  //   name: 'VICTORIA HOUSE SA',
  //   image: backgroundImg,
  //   imageAlt: 'test',
  //   localization: [
  //     '1c rue Gabriel Lippmann',
  //     'L-5365 Munsbach\nGrand-Duchy of Luxembourg',
  //   ],
  // }

  return (
    <>
      <SEO />
      <div id="home" />
      <Slider
        items={slides}
        // info={{
        //   number: '12 100',
        //   text: 'Apartments<br/>under construction<br/>and in preparation',
        // }}
        scrollTo="#experience"
      />
      <main>
        <Promo features={features} />
        <Map maps={maps} />
        <About
          background={HOMEPAGE.aboutBg.imageFile.childImageSharp.fluid}
          cards={cards}
        />
        {/* <Contact mainLocalization={localization} source="main" /> */}
      </main>
    </>
  )
}

export const query = graphql`
  query HomePage {
    wpgraphql {
      page(id: "/strona-glowna/", idType: URI) {
        PageHome {
          bannerSlides {
            bannerSlideHighlight
            bannerSlideText
            bannerSlideImage {
              title
              sourceUrl
              imageFile {
                childImageSharp {
                  fluid(maxHeight: 1080) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          promoCards {
            promoCardNumber
            promoCardText
            promoCardUnit
          }
          maps {
            mapsLink
            mapsCity
          }
          aboutBg {
            sourceUrl
            imageFile {
              childImageSharp {
                fluid(maxHeight: 1080) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          aboutCards {
            aboutCardHeader {
              aboutCardHeaderHighlight
              aboutCardHeaderText
            }
            aboutCardDescription
            aboutCardImg {
              title
              sourceUrl
              imageFile {
                childImageSharp {
                  fluid(maxWidth: 1080) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

IndexPage.propTypes = {
  data: PropTypes.objectOf(PropTypes.object).isRequired,
}

export default IndexPage
